var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageImgMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.7985H9.33333M9.33333 6.7985H14.6667C14.6667 10.7467 12.5216 14.1938 9.33333 16.0382M9.33333 6.7985L9.33333 4.13184M9.33333 16.0382C7.76441 16.9457 5.94287 17.4652 4 17.4652M9.33333 16.0382C7.71399 15.1014 6.36375 13.7512 5.42701 12.1318M9.33333 16.0382C10.9023 16.9457 12.7238 17.4652 14.6667 17.4652M28 28.1318V28.0479C28 26.7235 27.8599 25.4113 27.5869 24.1318M17.3333 28.1318V28.0479C17.3333 26.7235 17.4734 25.4113 17.7465 24.1318M17.7465 24.1318C18.3519 21.2947 19.6109 18.6182 21.4455 16.3249C22.0716 15.5424 23.2618 15.5424 23.8878 16.3249C25.7224 18.6182 26.9815 21.2947 27.5869 24.1318M17.7465 24.1318H27.5869",
    stroke: "#4C60E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageImgMob);
export default __webpack_public_path__ + "static/media/languageImgMob.6899bea5334596e2e7b8b52db9f98f78.svg";
export { ForwardRef as ReactComponent };